import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.bold.js";
import "core-js/modules/es6.number.constructor.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// this is the raw web typography implementation
import React from 'react';
import baseStyles, { mergeStyles } from '@nerdwallet/base-styles/react';

var getSizeRuleName = function getSizeRuleName(_ref) {
  var size = _ref.size;
  return "type-".concat(size);
};

var getFamilyRuleName = function getFamilyRuleName(_ref2) {
  var chronicle = _ref2.chronicle,
      gotham = _ref2.gotham,
      size = _ref2.size;

  if (chronicle) {
    if (Number(size) >= 3) {
      return 'chronicle-display';
    }

    return 'chronicle';
  }

  if (gotham) {
    return 'gotham';
  }

  return null;
};
/**
 * Returns a design token from the design system (eg. color-red) based
 * on props. Note the order of precedence,
 * eg. color takes precedence over error, error over light, etc.
 * @returns {(string|null)} the color name or null
 */


var getColor = function getColor(_ref3) {
  var error = _ref3.error,
      color = _ref3.color,
      light = _ref3.light;

  if (color) {
    return "color-".concat(color);
  }

  if (error) {
    return 'color-red-dark';
  }

  if (light) {
    return 'color-neutral-darker';
  }

  return null;
};

var shouldUnbold = function shouldUnbold(_ref4) {
  var bold = _ref4.bold,
      component = _ref4.component;
  return bold === false || !bold && typeof component === 'string' && /^h[1-6]$/i.test(component);
};

export var TypeImpl = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var _ref6;

  var bold = _ref5.bold,
      children = _ref5.children,
      chronicle = _ref5.chronicle,
      className = _ref5.className,
      color = _ref5.color,
      component = _ref5.component,
      error = _ref5.error,
      gotham = _ref5.gotham,
      inline = _ref5.inline,
      italic = _ref5.italic,
      light = _ref5.light,
      size = _ref5.size,
      style = _ref5.style,
      uppercase = _ref5.uppercase,
      otherProps = _objectWithoutProperties(_ref5, ["bold", "children", "chronicle", "className", "color", "component", "error", "gotham", "inline", "italic", "light", "size", "style", "uppercase"]);

  var Component = component || (inline ? 'span' : 'p');
  var sizeRuleName = getSizeRuleName({
    size: size
  });
  var familyRuleName = getFamilyRuleName({
    size: size,
    gotham: gotham,
    chronicle: chronicle
  });
  var colorName = getColor({
    color: color,
    error: error,
    light: light
  });
  return /*#__PURE__*/React.createElement(Component, _extends({}, mergeStyles(baseStyles([colorName, familyRuleName, (_ref6 = {}, _defineProperty(_ref6, sizeRuleName, size != null), _defineProperty(_ref6, "bold", bold), _defineProperty(_ref6, "italic", italic), _defineProperty(_ref6, "uppercase", uppercase), _defineProperty(_ref6, 'font-weight-normal', shouldUnbold({
    bold: bold,
    component: Component
  })), _ref6)]), {
    className: className,
    style: style
  }), {
    // @ts-expect-error -- the `ref` is typed as `HTMLSpanElement`, but the `ref`
    // prop on `<Component>` could be either `HTMLSpanElement` or
    // `HTMLParagraphElement`. These types don't really matter internally;
    // what matters is that the external types behave well for consumers,
    // and that's what our types give us.
    ref: ref
  }, otherProps), children);
});
TypeImpl.displayName = 'TypeImpl';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require -- directive added automatically by Shepherd migration
  var PropTypes = require('prop-types');

  TypeImpl.propTypes = {
    children: PropTypes.node,

    /**
     * By default `<Type>` is block-level (renders a <p> tag). If the inline prop
     * is used, `<Type>` is inline (renders a <span> tag).
     */
    inline: PropTypes.bool,

    /** Font size: 1=smallest, 5=biggest. Size is inherited if not specified. */
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Use Gotham font. Font is inherited if not specified. */
    gotham: PropTypes.bool,

    /** Use Chronicle font. Font is inherited if not specified. */
    chronicle: PropTypes.bool,

    /** Bold styling. */
    bold: PropTypes.bool,

    /**
     * Flag to indicate if the color of the text will be color-red. Takes
     * precedence over the `light` prop if used together.
     */
    error: PropTypes.bool,

    /** Italic styling. */
    italic: PropTypes.bool,

    /** Turn text uppercase and spaces out letters. */
    uppercase: PropTypes.bool,

    /** Sets text to "neutral-darker" defined in base-styles. */
    light: PropTypes.bool,

    /**
     * Sets text to a color defined by base-styles (overrides `error` and `light` props).
     */
    color: PropTypes.string,

    /** Use a custom component instead of the default <p> component. */
    component: PropTypes.elementType,
    className: PropTypes.string
  };
}